import { RestCampaignData, SetlistCover } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class CampaignRest {
  private host: string = host

  public get (token: string | null, id: number): Promise<RestCampaignData> {
    return axios.get(`${this.host}/api/campaigns/${id}`, token ? {
      headers: {
        Authorization: token
      }
    } : {}).then((res) => res.data)
  }

  // Pre-compressed, base64-encoded setlist cover image for uploading to Spotify
  // when creating the playlist client-side. Fetched lazily, at generation time.
  public getSetlistCover (id: number): Promise<SetlistCover> {
    return axios.get(`${this.host}/api/campaigns/${id}/setlist-cover`).then((res) => res.data)
  }

  public create (token: string|null, data: RestCampaignData): Promise<RestCampaignData> {
    return axios.post(`${host}/api/campaigns`, data, token ? {
      headers: {
        Authorization: token
      }
    } : {}
    ).then((res) => res.data)
  }

  public async update (token: string|null, id: number, data: RestCampaignData): Promise<RestCampaignData> {
    const resp = await axios.patch(`${host}/api/campaigns/${id}`, data, token ? {
      headers: {
        Authorization: token
      }
    } : {})
    return resp.data
  }
}

export default new CampaignRest()
